var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFileDownload = function SvgFileDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42857 0C4.42857 0 2.85714 1.65 2.85714 3.75V12.75C2.85714 14.025 3.78571 15 5 15C6.21429 15 7.14286 14.025 7.14286 12.75V5.25C7.14286 4.8 6.85714 4.5 6.42857 4.5C6 4.5 5.71429 4.8 5.71429 5.25V12.75C5.71429 13.2 5.42857 13.5 5 13.5C4.57143 13.5 4.28571 13.2 4.28571 12.75V3.75C4.28571 2.475 5.21429 1.5 6.42857 1.5C7.64286 1.5 8.57143 2.475 8.57143 3.75V12.75C8.57143 14.85 7 16.5 5 16.5C3 16.5 1.42857 14.85 1.42857 12.75V0.75C1.42857 0.3 1.14286 0 0.714286 0C0.285714 0 0 0.3 0 0.75V12.75C0 15.675 2.21429 18 5 18C7.78571 18 10 15.675 10 12.75V3.75C10 1.65 8.42857 0 6.42857 0Z",
    fill: "#FF7F00"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FileDownload.e2b4dc0b.svg";
export { ForwardRef as ReactComponent };